export enum SelectionRoute {
  LIST = 'list',
  DASHBOARD = 'dashboard',
  COMPARATOR = 'comparator',
}
